import { LOCALE_ID, Inject, Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-auth-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {
  test: Date = new Date();
  language: any;
  termsConditionsLink: string = 'https://www.osmoscloud.com/termsOfService';
  privacyPolicy: string = 'https://www.osmoscloud.com/privacyPolicy';
  private subscriptions: Subscription[] = [];

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    const initialLang = localStorage.getItem('language') || this.translate.currentLang || 'en';
    this.updateLinks(initialLang);

    const querySub = this.activatedRoute.queryParams.subscribe((params) => {
      this.language = params?.language;
      const lang = params?.language || localStorage.getItem('language') || this.translate.currentLang;
      this.updateLinks(lang);
    });
    this.subscriptions.push(querySub);

    const langSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateLinks(event.lang);
    });
    this.subscriptions.push(langSub);
  }

  updateLinks(lang: string) {
    const cleanLang = (lang || '').toLowerCase();
    if (cleanLang === 'es') {
      this.termsConditionsLink = 'https://www.osmoscloud.com/es/termsOfService';
      this.privacyPolicy = 'https://www.osmoscloud.com/es/privacyPolicy';
    } else if (cleanLang === 'fr') {
      this.termsConditionsLink = 'https://www.osmoscloud.com/fr/termsOfService';
      this.privacyPolicy = 'https://www.osmoscloud.com/fr/privacyPolicy';
    } else {
      this.termsConditionsLink = 'https://www.osmoscloud.com/termsOfService';
      this.privacyPolicy = 'https://www.osmoscloud.com/privacyPolicy';
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
